"use client"

import { useSearchParams } from "next/navigation"
import { Suspense } from "react"
import { BlogPageClient } from "./BlogPageClient"
import { BlogDetailClient } from "./BlogDetailClient"

function BlogRouterInner() {
  const searchParams = useSearchParams()
  const slug = searchParams.get("slug")

  if (slug) {
    return <BlogDetailClient slug={slug} />
  }
  return <BlogPageClient />
}

export function BlogRouter() {
  return (
    <Suspense fallback={<BlogPageClient />}>
      <BlogRouterInner />
    </Suspense>
  )
}
